import type { SearchRound } from '../types';
import type { CurrentStep } from '../enums';

/**
 * 搜索轮次服务接口
 * 负责同步操作SearchRoundsModel中的数据
 */
export interface SearchRoundsService {
    /**
     * 设置搜索轮次数据
     * @param searchRounds - 搜索轮次数据数组
     */
    setSearchRounds(searchRounds: SearchRound[]): void;

    /**
     * 选择搜索轮次
     * @param roundIndex - 搜索轮次索引
     * @returns 选中的搜索轮次
     */
    selectSearchRound(roundIndex: number): SearchRound;

    /**
     * 更新搜索式
     * @param roundIndex - 搜索轮次索引
     * @param newQuery - 新的搜索式
     */
    updateSearchQuery(roundIndex: number, newQuery: string): void;

    /**
     * 更新搜索轮次状态
     * @param roundIndex - 搜索轮次索引
     * @param status - 新状态
     */
    updateSearchRoundStatus(roundIndex: number, status: SearchRound['status']): void;

    /**
     * 更新搜索轮次的当前步骤
     * @param roundIndex - 搜索轮次索引
     * @param currentStep - 当前步骤
     */
    updateCurrentStep(roundIndex: number, currentStep: SearchRound['currentStep']): void;

    /**
     * 更新专利数量
     * @param roundIndex - 搜索轮次索引
     * @param patentCount - 专利数量
     */
    updatePatentCount(roundIndex: number, patentCount: number): void;

    /**
     * 更新指定步骤的筛选后专利数量
     * @param roundIndex - 搜索轮次索引
     * @param step - 当前步骤
     * @param count - 筛选后的专利数量
     */
    updateFilteredPatentCount(roundIndex: number, step: CurrentStep, count: number): void;

    /**
     * 获取当前选中的搜索轮次
     * @returns 当前选中的搜索轮次，如果没有选中则返回undefined
     */
    getSelectedSearchRound(): SearchRound | undefined;

    /**
     * 获取当前选中的搜索轮次索引
     * @returns 当前选中的搜索轮次索引，如果没有选中则返回-1
     */
    getSelectedSearchRoundIndex(): number;

    /**
     * 获取所有搜索轮次
     * @returns 所有搜索轮次数组
     */
    getAllSearchRounds(): SearchRound[];

    /**
     * 添加新的搜索轮次
     * @param searchRound - 新的搜索轮次
     */
    addSearchRound(searchRound: SearchRound): void;

    /**
     * 删除搜索轮次
     * @param roundIndex - 搜索轮次索引
     */
    removeSearchRound(roundIndex: number): void;
}

export const SearchRoundsService = Symbol('SearchRoundsService');
